import { DatePicker, Form } from "antd";
import K from "utilities/constants";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFDatePicker({
  title = "Title",
  isFormItem = true,
  className,
  placeholder = "",
  formItemName = "",
  required = true,
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const renderField = () => (
    <DatePicker
      placeholder={placeholder}
      format={K.DateFormat.DashUSFormat}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        initialValue={null}
        rules={required && [{ required: true, message: `Enter  ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
